import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 链动 #10027
export default [{
  path: "/city_merchant_store/:type?",
  component: function component() {
    return import("../../../views/city-merchant-store/city_merchant_store.vue");
  },
  name: "city_merchant_store",
  meta: {
    title: "我的门店",
    foot: true
  }
}];